// SocketProvider.js (opcional, si querés usar contexto global)
import React, { createContext, useContext, useEffect, useRef } from "react";
import { farmageo_api, frontendEntorno } from "./config";
import { io } from "socket.io-client";

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const socketRef = useRef(null);

  useEffect(() => {
    socketRef.current = io(farmageo_api); // o tu servidor
    console.log("Socket conectado");

    return () => {
      socketRef.current.disconnect();
      console.log("Socket desconectado");
    };
  }, []);

  return (
    <SocketContext.Provider value={socketRef.current}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);

export function startSocketConnection(data) {
  return io(farmageo_api, {
    auth: {
      authorization: window.localStorage.getItem("token"),
      "x-connection": frontendEntorno.connection,
      "x-frontend-origin": frontendEntorno.origin,
    },
    query: Object.assign(data, {
      user: window.localStorage.getItem("user") || "",
    }),
  });
}
